import * as formWizardConstants from './constants';
import 'element-closest-polyfill';

/**
 * Gets the step associated with an element
 *
 * @param {Element} element
 */
export default function getStep(element) {
  if (!element) return;
  return element.closest(formWizardConstants.selectors.step);
}
